import React from 'react';
import { Typography, Box, Button, Divider } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Modal from '@mui/material/Modal';
import { getAppNameFromPackageName } from './utils';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '60%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const Devices = ({ user }: { user: any }) => {
  const [devices, setDevices] = React.useState<any[]>([]);
  const [fcmTopicModal, setFcmTopicModal] = React.useState<any>({ open: false, token: '' });

  React.useEffect(() => {
    if (user?.devices) {
      const a = Object.keys(user?.devices).map((key) => {
        const p = user?.devices[key];

        const appsInDevice = Object.keys(p).map((d) => {
          const app = p[d];

          return {
            app: d,
            appName: getAppNameFromPackageName(d),
            token: app.token,
            tokenUpdated: app.tokenUpdated,
            deviceName: app.deviceName,
            deviceId: app.id,
          };
        });

        return appsInDevice;
      });

      setDevices(a.flat());
    }
  }, [user]);

  if (devices) {
    return (
      <>
        <Modal
          open={fcmTopicModal.open}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              FCM Token
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              {fcmTopicModal.token}
            </Typography>
            <Divider />
            <Button
              onClick={() => setFcmTopicModal({ open: false, token: '' })}
              variant="contained"
              color="primary"
              style={{ marginLeft: '10px', marginRight: '10px' }}
            >
              Kopiera till clipboard
            </Button>
            <Button
              onClick={() => setFcmTopicModal({ open: false, token: '' })}
              variant="contained"
              color="primary"
              disabled
              style={{ marginLeft: '10px', marginRight: '10px' }}
            >
              Skicka test-push
            </Button>
            <Button
              onClick={() => setFcmTopicModal({ open: false, token: '' })}
              variant="contained"
              color="primary"
              style={{ marginLeft: '10px', marginRight: '10px' }}
            >
              Stäng
            </Button>
          </Box>
        </Modal>
        <TableContainer component={Paper}>
          <Table sx={{}} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left">App</TableCell>
                <TableCell align="left">Enhet</TableCell>
                <TableCell align="left">Enhets Id</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {devices?.map((row: any) => (
                <TableRow
                  key={row.key}
                  sx={{
                    '&:last-child td, &:last-child th': {
                      border: 0,
                    },
                  }}
                >
                  <TableCell align="left">{row.appName}</TableCell>
                  <TableCell align="left">{row.deviceName}</TableCell>
                  <TableCell align="left">{row.deviceId}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    );
  }

  return null;
};

export default Devices;
